module.exports = __webpack_public_path__ + "img/instagram.a7fb1f92.png";